import { useNavigate } from 'react-router'
import { useAtomValue, useSetAtom } from 'jotai'

import routes, { RouteKeys } from 'const/routes'
import { cardStatusTrackerModalContainerId } from 'const/modalContainerId'
import isFeatureFlagEnabled from 'helpers/isFeatureFlagEnabled'
import {
  pendingAccountServicesLaunchAtom,
  selectedAccountAtom
} from 'store/atoms'

const FeatureRouteMap: Record<string, RouteKeys> = {
  disputes: 'DISPUTES',
  activity: 'ACTIVITY',
  alerts: 'ALERTS',
  promotions: 'PROMOTIONS',
  statements: 'STATEMENTS'
}

const useHandleNavigate = () => {
  const navigate = useNavigate()
  const setPendingAccountServicesLaunch = useSetAtom(
    pendingAccountServicesLaunchAtom
  )
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const handleNavigate = (feature: string) => {
    if (
      feature === 'track-your-card' &&
      isFeatureFlagEnabled('isCardStatusTrackerEnabled')
    ) {
      navigate(routes.ACCOUNT_SERVICES)
      setPendingAccountServicesLaunch({
        type: 'modal',
        modal: 'CardStatusTracker',
        triggerId: cardStatusTrackerModalContainerId(selectedAccount)
      })
      // Avoid falling through to the default Home route for track your card scenario
      return
    }
    const routeKey = FeatureRouteMap[feature] ?? 'HOME'
    const path = routes[routeKey]
    navigate(path)
  }

  return {
    handleNavigate
  }
}

export default useHandleNavigate
